<template>
  <div>
    <h1 class="mobiTitle white lg content" id="contentTitle">
      {{ $t("terms") }}
    </h1>
    <span v-if="lang_a4all == 'slovakia'">
      <terms-slovakia />
    </span>
    <span v-if="lang_a4all == 'czech'">
      <terms-czech />
    </span>
    <span v-else>
      <terms-english />
    </span>
  </div>
</template>

<script>
import TermsEnglish from "./TermsEnglish";
import TermsSlovakia from "./TermsSlovakia";
import { mapGetters } from "vuex";
import TermsCzech from "./TermsCzech.vue";

export default {
  computed: mapGetters(["lang_a4all", "country_a4all"]),
  components: {
    "terms-english": TermsEnglish,
    "terms-slovakia": TermsSlovakia,
    TermsCzech,
  },
  methods: {},
};
</script>

<style  lang="scss">
.apps4all {
  .mobitxt {
    margin: 8px 0px;
    padding-left: 25px;
    color: #fff;
  }
  .mobiFaq {
    margin: 25px 0px;
    color: #fff;
    .mobitxt {
      margin: 8px 0px;
      padding-left: 25px;
      color: #fff;
    }
    .mobiTitle {
      padding: 12px;
      background: #f1f1f1;
      color: #000;
      font-weight: 600;
    }
    li {
      font-size: 1rem;
      line-height: 1.2;
      font-weight: 300;
      margin-bottom: 8px;
    }
  }
}
.ar_layout {
  .apps4all {
    ul {
      text-align: right;
      direction: rtl;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/apps4all/Terms.vue